import { useEffect, useRef } from 'react';

export function HeroMatrixRain() {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return undefined;
    const ctx = canvas.getContext('2d');
    if (!ctx) return undefined;

    let animId: number;
    let lastTime = 0;
    const targetFPS = 20;
    const frameInterval = 1000 / targetFPS;
    const fontSize = 12;
    const katakana = 'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヲン';
    const digits = '0123456789';
    const words = 'PINGSERVERLAGNOPINGROUTEBOOSTFPS';
    const allChars = katakana + digits + words;

    function resize() {
      const parent = canvas!.parentElement;
      if (!parent) return;
      canvas!.width = parent.clientWidth;
      canvas!.height = parent.clientHeight;
    }
    resize();

    const columns = Math.floor(canvas.width / fontSize);
    const drops: number[] = new Array(columns).fill(0).map(() => Math.random() * -100);
    const speeds: number[] = new Array(columns).fill(0).map(() => 0.4 + Math.random() * 0.5);

    function draw(timestamp: number) {
      animId = requestAnimationFrame(draw);

      const delta = timestamp - lastTime;
      if (delta < frameInterval) return;
      lastTime = timestamp - (delta % frameInterval);

      ctx!.fillStyle = 'rgba(8, 8, 9, 0.04)';
      ctx!.fillRect(0, 0, canvas!.width, canvas!.height);

      ctx!.font = `${fontSize}px monospace`;

      for (let i = 0; i < columns; i += 1) {
        const char = allChars[Math.floor(Math.random() * allChars.length)];
        const x = i * fontSize;
        const y = drops[i]! * fontSize;

        ctx!.shadowColor = '#00FF41';
        ctx!.shadowBlur = 12;
        ctx!.fillStyle = 'rgba(0, 255, 65, 1)';
        ctx!.fillText(char!, x, y);
        ctx!.shadowBlur = 0;

        const trailLen = 12 + Math.floor(Math.random() * 6);
        for (let t = 1; t < trailLen; t += 1) {
          const trailY = y - t * fontSize;
          if (trailY < 0) break;
          if (Math.random() <= 0.35) {
            const trailChar = allChars[Math.floor(Math.random() * allChars.length)];
            const alpha = Math.max(0, 1 - t / trailLen);
            const g = Math.floor(100 + 155 * alpha);
            ctx!.fillStyle = `rgba(10, ${g}, 8, ${alpha * 0.6})`;
            ctx!.fillText(trailChar!, x, trailY);
          }
        }

        drops[i]! += speeds[i]!;

        if (drops[i]! * fontSize > canvas!.height && Math.random() > 0.96) {
          drops[i] = Math.random() * -30;
          speeds[i] = 0.4 + Math.random() * 0.5;
        }
      }
    }

    animId = requestAnimationFrame(draw);
    window.addEventListener('resize', resize);
    return () => {
      cancelAnimationFrame(animId);
      window.removeEventListener('resize', resize);
    };
  }, []);

  return <canvas ref={canvasRef} className='pointer-events-none absolute inset-0 size-full' style={{ opacity: 0.55 }} aria-hidden='true' />;
}
